<div class="d-flex flex-column">
  <form (ngSubmit)="onKeywordSearch(true)" [formGroup]="keywordSearchForm">
    <div class="row">
      <div class="col-3">
        <span class="search-text">Member's first name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter first name"
          formControlName="firstName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Member's middle name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter middle name"
          formControlName="middleName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Member's last name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter last name"
          formControlName="lastName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Guardian's first name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter First Name"
          formControlName="guardianFirstName"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-3">
        <span class="search-text">Guardian's middle name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter middle name"
          formControlName="guardianMiddleName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Guardian's last name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter last name"
          formControlName="guardianLastName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Ritwik's first name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter First Name"
          formControlName="ritwikFirstName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Ritwik's middle name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter middle name"
          formControlName="ritwikMiddleName"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-3">
        <span class="search-text">Ritwik's last name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter last name"
          formControlName="ritwikLastName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Pincode</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter PIN Code"
          formControlName="pincode"
        />
      </div>


      <div class="col-6">
        <span class="search-text">Address</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Enter Address"
          formControlName="address"
        />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-3 d-flex flex-column">
        <span class="search-text mb-2">State</span>
        <mat-form-field class="select-mat-form-field">
          <mat-select
            name="state"
            class="custom-mat-select"
            id="state"
            (selectionChange)="getDistrictList($event)"
            formControlName="stateName"
            placeholder="Select State"
          >
            @for (state of stateList; track state) {
            <mat-option [value]="state.stateName">{{
              state.stateName
            }}</mat-option>
            }
          </mat-select>
          <button
                mat-icon-button
                *ngIf="keywordSearchForm.get('stateName')?.value "
                matSuffix
                (click)="clearStateSelection($event)"
                class="clear-button"
              >
                <mat-icon class="clear-icon">clear</mat-icon>
              </button>
        </mat-form-field>
      </div>
      <div class="col-3 d-flex flex-column">
        <span class="search-text mb-2">District</span>
        <mat-form-field class="select-mat-form-field">
          <mat-select
            name="district"
            id="district"
            formControlName="districtName"
            placeholder="Select District"
          >
            @for (district of districtList; track district) {
            <mat-option [value]="district.district_name">{{
              district.district_name
            }}</mat-option>
            }
          </mat-select>
          <button
                mat-icon-button
                *ngIf="keywordSearchForm.get('districtName')?.value"
                matSuffix
                (click)="clearDistrictSelection($event)"
                class="clear-button"
              >
                <mat-icon class="clear-icon">clear</mat-icon>
            </button>
        </mat-form-field>
      </div>
      <div class="col-3">
        <span class="search-text">Initiation date</span>
        <input
          class="dp-input-control update-input mt-2"
          type="date"
          formControlName="initiationDate"
        />
      </div>
    </div>

    <div class="d-flex align-items-center btn-margin">
      <button class="dp-secondary-btn clear-btn" type="reset" (click)="clearEntries()">
        Clear Entries
      </button>
      <button class="dp-primary-btn search-btn ms-3">Search</button>
    </div>
  </form>

  @if(isLoader){
    <table class="dp-table">
      <thead class="dp-table-header">
        <tr>
          <th>Sl.no</th>
          <th>Mem Status</th>
          <th>District</th>
          <th>Name</th>
          <th>Guardian</th>
          <th>Initiation Date</th>
          <th>Ritwik</th>
          <th>Pin</th>
          <th>Adress</th>
        </tr>
      </thead>
      <tbody class="dp-table-body">
        <tr *ngFor="let i of [].constructor(numberOfLoaders)">
          <td *ngFor="let j of [].constructor(9)">
            <dp-loader></dp-loader>
          </td>
        </tr>
      </tbody>
    </table>
  }
  @else if(responseData.length>0){
    <div class="dp-table-scroll table-container"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000"
      (scrolled)="onKeywordSearch(false)">
    <dp-table
      [dataTable]="responseData"
      [displayedColumns]="displayColumnData"
      [componentMap]="cellComponentMap"
      [columnConfs]="columnConfs"
      [isLoader]="isLoader"
      (cellClick)="onCellClick($event)"
    ></dp-table>
  </div>
  }
  @else {
    <div class="noData" *ngIf="noDataFound">
      <div class="placeholderTable"></div>
      <p>No data found!</p>
    </div>
  }
  
</div>
